// extracted by mini-css-extract-plugin
export default {"cls1":"IsGONkKkF4NnlLLljyZ5","cls2":"YmEyU2v3DFScQW1uTOkX IsGONkKkF4NnlLLljyZ5"};